export type BackpackChip = { text: string; belongsInPrompt: boolean; conceptId: string };
export type BackpackRound = { goal: string; chips: BackpackChip[] };

const S = "scene_safety";
const B = "bleeding_basic";
const E = "emergency_call";
const R = "recovery_position";

export const FIRST_AID_BACKPACK_DECK: readonly BackpackRound[] = [
  {
    goal: "You’re writing a short note on what to do before touching an injured person.",
    chips: [
      { text: "Look for traffic, fire, or violence first.", belongsInPrompt: true, conceptId: S },
      {
        text: "Only help if the scene is safe enough for you.",
        belongsInPrompt: true,
        conceptId: S,
      },
      { text: "Call for professional help if available.", belongsInPrompt: true, conceptId: E },
      { text: "Tap dance for good luck before helping.", belongsInPrompt: false, conceptId: S },
      { text: "Ignore smoke or wires and rush in.", belongsInPrompt: false, conceptId: S },
    ],
  },
  {
    goal: "List what to include when you call emergency services.",
    chips: [
      { text: "Exact address or clear landmark.", belongsInPrompt: true, conceptId: E },
      { text: "What happened in one or two sentences.", belongsInPrompt: true, conceptId: E },
      {
        text: "Victim is breathing / not breathing (if you can tell).",
        belongsInPrompt: true,
        conceptId: E,
      },
      {
        text: "Your medical school diagnosis of the injury.",
        belongsInPrompt: false,
        conceptId: E,
      },
    ],
  },
  {
    goal: "Steps for heavy bleeding from a forearm while you wait for help.",
    chips: [
      { text: "Apply firm pressure with a clean cloth.", belongsInPrompt: true, conceptId: B },
      { text: "Keep pressure steady; add layers if soaked.", belongsInPrompt: true, conceptId: B },
      { text: "Elevate the arm if training says it is safe.", belongsInPrompt: true, conceptId: B },
      { text: "Remove the cloth every few seconds to peek.", belongsInPrompt: false, conceptId: B },
    ],
  },
  {
    goal: "When recovery position is a reasonable idea.",
    chips: [
      {
        text: "Unconscious but breathing and no spinal injury concern per training.",
        belongsInPrompt: true,
        conceptId: R,
      },
      {
        text: "Airway may be easier to keep open on the side.",
        belongsInPrompt: true,
        conceptId: R,
      },
      {
        text: "Support the head in line with training you were taught.",
        belongsInPrompt: true,
        conceptId: R,
      },
      {
        text: "Whenever you feel like rolling anyone on the ground.",
        belongsInPrompt: false,
        conceptId: R,
      },
    ],
  },
  {
    goal: "Quick scene check at a roadside crash (simplified).",
    chips: [
      { text: "Stand where oncoming traffic won’t hit you.", belongsInPrompt: true, conceptId: S },
      {
        text: "Turn on hazard lights if it is your vehicle and safe.",
        belongsInPrompt: true,
        conceptId: S,
      },
      {
        text: "Call emergency line with location before moving people.",
        belongsInPrompt: true,
        conceptId: E,
      },
      { text: "Film a video for social media first.", belongsInPrompt: false, conceptId: S },
    ],
  },
  {
    goal: "What to say first on an emergency call (order can vary by service).",
    chips: [
      { text: "Where you are.", belongsInPrompt: true, conceptId: E },
      { text: "What you see (calm, short).", belongsInPrompt: true, conceptId: E },
      { text: "Stay on the line if they ask.", belongsInPrompt: true, conceptId: E },
      {
        text: "Share the victim’s entire social history first.",
        belongsInPrompt: false,
        conceptId: E,
      },
    ],
  },
];
